// Libs
import axios, { AxiosResponse } from 'axios';
// App
import { SUBSCRIPTION_URL } from './subscription.constants';
import {
  CreateSubscriptionCheckoutSessionParam,
  CreateSubscriptionBillingPortalSessionParam,
  UpdateSubscriptionPlanParam,
} from './subscription.interfaces';
import { useAxiosPostRequest, AxiosHookResponse, useAxiosPutRequest } from '../../utils/axios-request.hooks';
import { API_COMMON_BASE_URL } from '../../utils/api.constants';

/**
 * Create subscription checkout session api hook
 */
export const useCreateSubscriptionCheckoutSession = (): AxiosHookResponse<
  CreateSubscriptionCheckoutSessionParam,
  string
> => {
  const url = `${API_COMMON_BASE_URL}/${SUBSCRIPTION_URL}/checkout-session`;

  return useAxiosPostRequest(url);
};

/**
 * Create subscription checkout session api
 */
export const createSubscriptionBillingPortalSession = (
  param: CreateSubscriptionBillingPortalSessionParam
): Promise<AxiosResponse<string>> => {
  const url = `${API_COMMON_BASE_URL}/${SUBSCRIPTION_URL}/billing-portal-session`;

  return axios.post(url, param);
};

/**
 * Create subscription checkout session api hook
 */
export const useCreateSubscriptionBillingPortalSession = (): AxiosHookResponse<
  CreateSubscriptionBillingPortalSessionParam,
  string
> => {
  const url = `${API_COMMON_BASE_URL}/${SUBSCRIPTION_URL}/billing-portal-session`;

  return useAxiosPostRequest(url);
};

/**
 * Update subscription (upgrade or downgrade)
 */
export const useUpdateSubscription = (): AxiosHookResponse<UpdateSubscriptionPlanParam, string> => {
  const url = `${API_COMMON_BASE_URL}/${SUBSCRIPTION_URL}`;

  return useAxiosPutRequest(url);
};
